module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/difference-183df7bc8ea4e6376f4b8555e10edbc1.svg";